/* Sugar Shell — storefront behaviour (no dependencies) */
(function () {
  'use strict';

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('ss-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ss-toast';
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.display = 'block';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.style.display = 'none'; }, 2600);
  }
  window.ssToast = toast;

  /* ---------- mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (!t) return;
    var nav = document.getElementById('ss-nav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input[name="quantity"], input[data-qty-input]');
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- variant picker ---------- */
  function initVariants(root) {
    var form = root.querySelector('[data-product-form], form[action*="/cart/add"]');
    if (!form) return;
    var data = root.querySelector('[data-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var wasEl = root.querySelector('[data-price-was]');
    var submit = form.querySelector('[data-add]');
    var money = root.getAttribute('data-money-format') || '{{amount}}';

    function fmt(cents) {
      var n = (cents / 100).toLocaleString(document.documentElement.lang || 'en-IN', {
        minimumFractionDigits: 0, maximumFractionDigits: 2
      });
      return money.replace(/\{\{\s*amount[^}]*\}\}/, n);
    }

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = selected();
      var match = variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = fmt(match.price);
      if (wasEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          wasEl.textContent = fmt(match.compare_at_price);
          wasEl.hidden = false;
        } else { wasEl.hidden = true; }
      }
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available
          ? submit.getAttribute('data-label-add')
          : submit.getAttribute('data-label-sold');
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) update();
    });
    update();
  }

  /* ---------- ajax add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form], form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-label-adding') || 'Adding…'; }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(serialize(form))
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body.description || res.body.message || 'Could not add to cart'); return; }
        var item = (res.body.items && res.body.items[0]) || res.body;
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? ' · ' + item.variant_title : '';
        toast(item.product_title + ' added' + variant);
        refreshCount();
      })
      .catch(function () { toast('Network error — please try again'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  });

  function serialize(form) {
    var fd = new FormData(form);
    var out = { items: [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10), properties: {} }] };
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value) out.items[0].properties[m[1]] = value;
    });
    if (!Object.keys(out.items[0].properties).length) delete out.items[0].properties;
    return out;
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ---------- product gallery ---------- */
  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        main.src = full;
        // The main image may carry a srcset from a previous render; clearing it
        // stops the browser re-picking the old source.
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.alt = thumb.getAttribute('data-alt') || main.alt;
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      });
    });
  }

  /* ---------- fit finder (3 steps) ---------- */
  function initFit(root) {
    var dataEl = root.querySelector('[data-fit-data]');
    var bandInput = root.querySelector('[data-fit-band]');
    var bustInput = root.querySelector('[data-fit-bust]');
    if (!dataEl || !bandInput || !bustInput) return;

    var data = JSON.parse(dataEl.textContent);
    var steps = data.steps || [];
    var journeys = data.journeys || [];
    var L = data.labels || {};

    var titleEl = root.querySelector('[data-fit-title]');
    var helpEl = root.querySelector('[data-fit-help]');
    var eyebrowEl = root.querySelector('[data-fit-eyebrow]');
    var sizeEl = root.querySelector('[data-fit-size]');
    var noteEl = root.querySelector('[data-fit-note]');
    var recEl = root.querySelector('[data-fit-recommended]');
    var backBtn = root.querySelector('[data-fit-back]');
    var nextBtn = root.querySelector('[data-fit-next]');
    var resetBtn = root.querySelector('[data-fit-reset]');

    var step = 1;
    var journey = null;

    var CUPS = ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F'];

    // Same arithmetic as the original design: round both measurements, take the
    // difference for the cup, and round the band up to the next even number.
    function recommendedSize() {
      var band = Math.round(parseFloat(bandInput.value) || 0);
      var bust = Math.round(parseFloat(bustInput.value) || 0);
      if (!band || !bust) return null;
      var diff = Math.max(0, bust - band);
      var bandRounded = band % 2 === 0 ? band : band + 1;
      return bandRounded + CUPS[Math.min(diff, CUPS.length - 1)];
    }

    function show(n) {
      step = n;
      root.querySelectorAll('[data-fit-step]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-fit-step') !== String(n);
      });
      root.querySelectorAll('[data-fit-pip]').forEach(function (pip) {
        pip.classList.toggle('is-on', parseInt(pip.getAttribute('data-fit-pip'), 10) <= n);
      });

      var s = steps[n - 1] || {};
      if (titleEl) titleEl.textContent = s.title || '';
      if (helpEl) helpEl.textContent = s.help || '';
      if (eyebrowEl) {
        eyebrowEl.textContent = (L.eyebrow || '') + ' · ' +
          (L.stepOf || 'Step {{n}} of 3').replace('{{n}}', n);
      }

      if (backBtn) backBtn.hidden = n === 1;
      if (nextBtn) nextBtn.hidden = n === 3;
      if (resetBtn) resetBtn.hidden = n !== 3;
    }

    function renderResult() {
      var size = recommendedSize();
      var j = journeys[journey] || {};
      if (sizeEl) sizeEl.textContent = size || '—';
      if (noteEl) noteEl.textContent = j.note || '';
      if (!recEl) return;

      var products = j.products || [];
      if (!products.length) {
        recEl.innerHTML = '<p class="form-note">' + esc(L.empty || '') + '</p>';
        return;
      }

      recEl.innerHTML = products.map(function (p) {
        var variant = matchVariant(p.variants || [], size);
        var media = p.image
          ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">'
          : '<span class="card__media-empty"><span class="placeholder-label">' + esc(L.noImage || '') + '</span></span>';

        var action = variant
          ? '<form method="post" action="' + rootUrl() + 'cart/add" data-product-form>' +
              '<input type="hidden" name="id" value="' + variant.id + '">' +
              '<input type="hidden" name="quantity" value="1">' +
              '<button class="btn btn--primary btn--sm btn--block" type="submit" data-add ' +
                'data-label-add="' + esc(addLabel(size)) + '" ' +
                'data-label-adding="Adding…">' + esc(addLabel(size)) + '</button>' +
            '</form>'
          : '<a class="btn btn--ghost btn--sm btn--block" href="' + esc(p.url) + '">' +
              esc(L.chooseOptions || '') + '</a>';

        return '<div class="card">' +
            '<a class="card__media" href="' + esc(p.url) + '">' + media + '</a>' +
            '<div class="card__body">' +
              '<a class="card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
              '<span class="card__short">' + esc(p.short || '') + '</span>' +
              '<div class="card__price"><span class="price">' + esc(p.price || '') + '</span></div>' +
              action +
            '</div>' +
          '</div>';
      }).join('');
    }

    // A recommended size like "36C" only fits products sold in band sizes. For a
    // prosthesis sold by cup volume ("C") or a panty sold S–XXL, fall back to the
    // cup letter, then give up and send them to the product page.
    function matchVariant(variants, size) {
      if (!size) return null;
      var cup = size.replace(/^\d+/, '');
      var exact = find(variants, size);
      if (exact) return exact;
      return find(variants, cup);
    }

    function find(variants, value) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.available) continue;
        for (var k = 0; k < v.options.length; k++) {
          if (String(v.options[k]).toLowerCase() === String(value).toLowerCase()) return v;
        }
      }
      return null;
    }

    function addLabel(size) {
      return (L.addInSize || 'Add in size {{size}}').replace('{{size}}', size || '');
    }

    function rootUrl() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    root.querySelectorAll('[data-fit-journey]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        journey = parseInt(btn.getAttribute('data-fit-journey'), 10);
        root.querySelectorAll('[data-fit-journey]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          b.classList.toggle('is-selected', b === btn);
        });
        renderResult();
        show(3);
      });
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (step === 1) {
          if (!recommendedSize()) { toast(L.needMeasurements || 'Enter both measurements'); return; }
          show(2);
        } else if (step === 2) {
          if (journey === null) { toast(L.needJourney || 'Pick one to continue'); return; }
          renderResult();
          show(3);
        }
      });
    }

    if (backBtn) backBtn.addEventListener('click', function () { show(Math.max(1, step - 1)); });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        journey = null;
        root.querySelectorAll('[data-fit-journey]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.classList.remove('is-selected');
        });
        show(1);
      });
    }

    show(1);
  }

  /* ---------- awards / recognition slider ---------- */
  function initAwards(root) {
    var track = root.querySelector('[data-awards-track]');
    var dots = root.querySelectorAll('[data-awards-dot]');
    if (!track || !dots.length) return;
    var slides = track.querySelectorAll('[data-awards-slide]');

    function setActive(i) {
      dots.forEach(function (dot, idx) { dot.classList.toggle('is-active', idx === i); });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var slide = slides[parseInt(dot.getAttribute('data-awards-dot'), 10)];
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var center = track.scrollLeft + track.clientWidth / 2;
        var closest = 0;
        var closestDist = Infinity;
        slides.forEach(function (slide, idx) {
          var mid = slide.offsetLeft - track.offsetLeft + slide.offsetWidth / 2;
          var dist = Math.abs(mid - center);
          if (dist < closestDist) { closestDist = dist; closest = idx; }
        });
        setActive(closest);
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- boot ---------- */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-product-root]').forEach(initVariants);
    (scope || document).querySelectorAll('[data-product-root]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-fit-root]').forEach(initFit);
    (scope || document).querySelectorAll('[data-awards-root]').forEach(initAwards);
  }
  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
